import { useEffect, useMemo } from 'react';
import { useNavigate } from 'react-router-dom';
import { t } from 'i18next';
import { useInicisBillingPayment } from './hooks/useInicisBillingPayment';
import { ReactComponent as BlueArrowRightIcon } from '../../icons/blue.arrow.right.svg';
import { useGetMySubscription } from '../../domains/payments/ui/hooks/useGetMySubscription';
import { useChangeSubscription } from '../../domains/payments/ui/hooks/useChangeSubscription';
import { useBilling } from './hooks/useBilling';

const PaymentBillingPage = () => {
  const navigate = useNavigate();
  const searchParams = useMemo(() => new URLSearchParams(window.location.search), []);
  const { data: mySubscription } = useGetMySubscription();
  const { mutateAsync: changeSubscription, isLoading: isChangingSubscription } =
    useChangeSubscription();
  const { generateOrderId } = useBilling();

  const amount = searchParams.get('amount') ?? '';
  const productName = searchParams.get('productName') ?? '';
  const productId = searchParams.get('productId') ?? '';

  const { handleCreateOrder, user } = useInicisBillingPayment({
    amount,
    productName,
    productId
  });

  const handleCheckSubscription = async () => {
    if (!mySubscription?.subscriptionId) {
      return;
    }
    await generateOrderId(productId);
    try {
      const requestBody = {
        subscription: {
          product_id: productId
        }
      };

      const response = await changeSubscription(requestBody);
      if (response?.subscriptionId) {
        navigate('/payment/success');
      }
    } catch {
      navigate('/payment/fail');
    }
  };

  useEffect(() => {
    if (productId && amount && productName) {
      if (mySubscription?.subscriptionId && !isChangingSubscription) {
        void handleCheckSubscription();
        return;
      }
      void handleCreateOrder();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [productId, amount, productName, mySubscription, user, isChangingSubscription]);

  return (
    <div className="min-h-screen flex flex-col gap-[38px] items-center justify-center">
      <BlueArrowRightIcon width={65} height={65} />
      <p className="text-[24px] font-semibold text-text-main-lv2 leading-[28px] text-center">
        {t('InicisPaymentLaunch.moveToPayment')}
      </p>
    </div>
  );
};

export default PaymentBillingPage;
